
<div class="container my-5">
  <div class="card shadow">
    <div class="card-body p-5">

      <h1 class="text-center mb-4">Privacy Policy</h1>

      <p><strong>Last Updated:</strong> June 2026</p>

      <h4 class="mt-4">Introduction</h4>

      <p>
        <strong>S1AZ.COM</strong> Company is committed
        to protecting the privacy and security of our users. This Privacy Policy
        explains how we collect, use, store, and share information when you use
        the S1AZ.COM Sales Application ("App").
      </p>

      <p>
        The App is designed for business operations including sales order
        collection, delivery management, route tracking, field force monitoring,
        supervisor oversight, attendance management, customer visits, inventory
        management, and related business activities.
      </p>

      <p>
        By using the App, you agree to the collection and use of information in
        accordance with this Privacy Policy.
      </p>

      <hr />

      <h4>Who We Are</h4>

      <p>
        S1AZ.COM provides business software solutions for sales force automation,
        distribution management, delivery operations, customer management, and
        workforce monitoring.
      </p>

      <p>
        Website:
        <a href="https://s1az.com" target="_blank">https://s1az.com</a>
      </p>

      <h4 class="mt-4">Information We Collect</h4>

      <h5>Personal Information</h5>
      <p>We may collect the following information:</p>

      <ul>
        <li>Full Name</li>
        <li>Employee ID</li>
        <li>Username</li>
        <li>Password</li>
        <li>Email Address</li>
        <li>Phone Number</li>
        <li>Company Name</li>
        <li>Designation / Job Title</li>
        <li>Profile Picture</li>
        <li>Customer Information entered by users</li>
        <li>Any other information provided by your organization</li>
      </ul>

      <h5>Device Information</h5>

      <p>We may automatically collect:</p>

      <ul>
        <li>Device ID</li>
        <li>Android Advertising ID (if applicable)</li>
        <li>Device Model</li>
        <li>Operating System Version</li>
        <li>Application Version</li>
        <li>IP Address</li>
        <li>Mobile Network Information</li>
        <li>MAC Address (where permitted)</li>
        <li>Crash Logs and Diagnostic Data</li>
      </ul>

      <h5>Location Information</h5>

      <p>
        We collect precise and approximate location information, including:
      </p>

      <ul>
        <li>GPS Coordinates (Latitude and Longitude)</li>
        <li>Background Location Data</li>
        <li>Route Tracking Information</li>
        <li>Check-in and Check-out Locations</li>
        <li>Attendance Locations</li>
        <li>Delivery Locations</li>
        <li>Customer Visit Locations</li>
      </ul>

      <p>
        Location data may be collected even when the app is running in the
        background if enabled by your organization for business operations.
      </p>

      <h5>Contacts Information</h5>

      <p>With your permission, we may access:</p>

      <ul>
        <li>Contact Names</li>
        <li>Phone Numbers</li>
        <li>Business Contact Information</li>
      </ul>

      <p>
        This information is used to facilitate customer management,
        communication, and business operations.
      </p>

      <h5>Photos and Videos</h5>

      <p>The App may collect:</p>

      <ul>
        <li>Product Photos</li>
        <li>Customer Visit Photos</li>
        <li>Delivery Proof Photos</li>
        <li>Profile Photos</li>
        <li>Video Evidence for Deliveries or Visits</li>
      </ul>

      <p>
        Photos and videos may contain location metadata and timestamps.
      </p>

      <h5>Files and Documents</h5>

      <p>The App may access and store:</p>

      <ul>
        <li>PDF Files</li>
        <li>Invoices</li>
        <li>Delivery Documents</li>
        <li>Customer Documents</li>
        <li>Business Reports</li>
        <li>Other files uploaded by authorized users</li>
      </ul>

      <h5>Usage Information</h5>

      <p>We collect information about how the App is used, including:</p>

      <ul>
        <li>Login Activity</li>
        <li>Feature Usage</li>
        <li>Screen Access History</li>
        <li>Order Creation Activity</li>
        <li>Delivery Activities</li>
        <li>Customer Visit Records</li>
        <li>Attendance Records</li>
        <li>Application Performance Data</li>
      </ul>

      <h4 class="mt-4">Permissions We Request</h4>

      <p>The App may request the following permissions:</p>

      <h5>Location Permissions</h5>

      <ul>
        <li>ACCESS_FINE_LOCATION</li>
        <li>ACCESS_COARSE_LOCATION</li>
        <li>ACCESS_BACKGROUND_LOCATION</li>
        <li>FOREGROUND_SERVICE_LOCATION</li>
      </ul>

      <p>Used for:</p>

      <ul>
        <li>Employee tracking</li>
        <li>Route monitoring</li>
        <li>Attendance verification</li>
        <li>Customer visit verification</li>
        <li>Delivery verification</li>
        <li>Supervisor monitoring</li>
      </ul>

      <h5>Camera Permission</h5>

      <ul>
        <li>CAMERA</li>
      </ul>

      <p>Used for:</p>

      <ul>
        <li>Capturing delivery proof</li>
        <li>Customer visit photos</li>
        <li>Product photos</li>
        <li>Profile pictures</li>
        <li>Business documentation</li>
      </ul>

      <h5>Storage and File Permissions</h5>

      <p>Used for:</p>

      <ul>
        <li>Uploading documents</li>
        <li>Downloading reports</li>
        <li>Managing invoices</li>
        <li>Attaching files to business transactions</li>
      </ul>

      <h5>Contact Permission</h5>

      <ul>
        <li>READ_CONTACTS</li>
      </ul>

      <p>Used for:</p>

      <ul>
        <li>Customer contact management</li>
        <li>Business communication</li>
        <li>Contact synchronization</li>
      </ul>

      <h5>Network Permissions</h5>

      <p>Used for:</p>

      <ul>
        <li>Synchronizing business data</li>
        <li>Uploading orders</li>
        <li>Downloading reports</li>
        <li>Communicating with company servers</li>
      </ul>

      <h4 class="mt-4">How We Use Your Information</h4>

      <ul>
        <li>Provide and maintain the App</li>
        <li>Process sales orders</li>
        <li>Track deliveries</li>
        <li>Verify employee attendance</li>
        <li>Monitor field activities</li>
        <li>Manage customer visits</li>
        <li>Improve operational efficiency</li>
        <li>Generate business reports</li>
        <li>Ensure service security</li>
        <li>Detect fraud and misuse</li>
        <li>Provide customer support</li>
        <li>Comply with legal obligations</li>
        <li>Improve our products and services</li>
      </ul>

      <h4 class="mt-4">Sharing of Information</h4>

      <h5>With Your Organization</h5>

      <p>
        Data collected through the App may be shared with your employer,
        organization, distributor, or company administrator for operational and
        management purposes.
      </p>

      <h5>With Service Providers</h5>

      <p>
        We may share data with trusted third-party service providers that assist
        us with:
      </p>

      <ul>
        <li>Cloud Hosting</li>
        <li>Data Storage</li>
        <li>Analytics</li>
        <li>Technical Support</li>
        <li>Security Monitoring</li>
        <li>Notification Services</li>
      </ul>

      <h5>Legal Requirements</h5>

      <p>
        We may disclose information if required by law or in response to:
      </p>

      <ul>
        <li>Court Orders</li>
        <li>Government Requests</li>
        <li>Regulatory Requirements</li>
        <li>Law Enforcement Requests</li>
      </ul>

      <h5>Business Transfers</h5>

      <p>
        If S1AZ.COM is involved in a merger, acquisition, or sale of assets,
        user information may be transferred as part of that transaction.
      </p>

      <h4 class="mt-4">Data Retention</h4>

      <p>
        We retain personal information only as long as necessary to provide our
        services, meet business requirements, comply with legal obligations,
        resolve disputes, and enforce agreements.
      </p>

      <h4 class="mt-4">Data Security</h4>

      <p>
        We implement appropriate technical and organizational measures to
        protect your information, including:
      </p>

      <ul>
        <li>Secure Authentication</li>
        <li>Encrypted Data Transmission (HTTPS/SSL)</li>
        <li>Access Controls</li>
        <li>Server Security Monitoring</li>
        <li>Database Protection</li>
        <li>Regular Security Updates</li>
      </ul>

      <p>
        While we strive to protect your information, no method of transmission
        or storage is completely secure.
      </p>

      <h4 class="mt-4">Analytics</h4>

      <p>
        We may use analytics services to understand application usage and
        improve performance.
      </p>

      <ul>
        <li>Device Information</li>
        <li>Usage Statistics</li>
        <li>Crash Reports</li>
        <li>Performance Metrics</li>
      </ul>

      <h4 class="mt-4">Your Rights</h4>

      <p>
        Depending on applicable laws, you may have the right to:
      </p>

      <ul>
        <li>Access your personal data</li>
        <li>Correct inaccurate information</li>
        <li>Request deletion of your information</li>
        <li>Restrict processing</li>
        <li>Object to processing</li>
        <li>Request data portability</li>
        <li>Withdraw consent where applicable</li>
      </ul>

      <h4 class="mt-4">Children's Privacy</h4>

      <p>
        The App is intended for business and enterprise use only. We do not
        knowingly collect personal information from children under 13 years of age.
      </p>

      <h4 class="mt-4">Third-Party Services</h4>

      <p>
        The App may contain links to third-party websites or services. We are
        not responsible for the privacy practices of third-party services.
      </p>

      <h4 class="mt-4">International Data Transfers</h4>

      <p>
        Your information may be stored and processed in countries other than
        your country of residence. By using the App, you consent to such
        transfers where permitted by law.
      </p>

      <h4 class="mt-4">Changes to This Privacy Policy</h4>

      <p>
        We may update this Privacy Policy periodically. Any changes will be
        posted within the App and/or on our website.
      </p>

      <h4 class="mt-4">Contact Us</h4>

      <p>
        <strong>S1AZ.COM</strong><br />
        Website:
        <a href="https://s1az.com" target="_blank">https://s1az.com</a><br />
        Email:
        <a href="mailto:info@s1az.com">info&#64;s1az.com</a><br />
        Address: 227, East Rampura, Dhaka, 1219, Bangladesh<br />
        Phone:
        <a href="tel:+8801706088146">+8801706088146</a>
      </p>

      <hr />

    </div>
  </div>
</div>

